
import React from "react";
import { motion } from "framer-motion";

interface ProfileBioProps {
  bio: string;
  interests: string;
}

const ProfileBio = ({ bio, interests }: ProfileBioProps) => {
  return (
    <motion.div 
      className="space-y-4"
      variants={{ 
        hidden: { opacity: 0, y: 10 },
        visible: { opacity: 1, y: 0 }
      }}
    >
      <div>
        <h3 className="font-medium mb-1">About</h3>
        <p className="text-sm text-muted-foreground">{bio || 'No bio provided'}</p>
      </div>
      
      <div>
        <h3 className="font-medium mb-1">Interests</h3>
        <p className="text-sm text-muted-foreground">{interests || 'No interests specified'}</p>
      </div>
    </motion.div>
  );
};

export default ProfileBio;
